import Wrapper from '@/components/base/Wrapper';
import SuccessPage from '@/pages/Success';
import MenuLite from '@/components/menu/MenuLite';
import MenuAnalitic from '@/components/menu/MenuAnalitic';

export default [
  // School :: User Management
  {
    path: '/user-school',
    component: Wrapper,
    meta: { breadCrumb: 'menu.manage_user' },
    children: [
      {
        path: '',
        name: 'MasterUserSchool',
        component: () => import(/* webpackChunkName: "user-school-index" */ '@/pages/userschool'),
        meta: { rule: 'isSchoolAdmin', layout: 'default' }
      },
      {
        path: 'create',
        name: 'MasterUserSchoolCreate',
        component: () => import(/* webpackChunkName: "user-school-form" */ '@/pages/userschool/CreateEdit'),
        meta: { rule: 'isSchoolAdmin', layout: 'default', breadCrumb: 'content.user_create' }
      },
      {
        path: ':id/edit',
        name: 'MasterUserSchoolEdit',
        component: () => import(/* webpackChunkName: "user-school-form" */ '@/pages/userschool/CreateEdit'),
        meta: { rule: 'isSchoolAdmin', layout: 'default', breadCrumb: 'content.user_edit' }
      },
      {
        path: ':id/view',
        name: 'MasterUserSchoolDetail',
        component: () => import(/* webpackChunkName: "school-form" */ '@/pages/userschool/CreateEdit'),
        meta: { rule: 'isSchoolAdmin', layout: 'default', breadCrumb: 'content.user_view' },
        props: { editable: false }
      },
      {
        path: 'success',
        name: 'UserSchoolSuccess',
        component: SuccessPage,
        meta: { rule: 'isSchoolAdmin' },
        props: { type: 'userschool' }
      },
      {
        path: 'success',
        name: 'UserSchoolUpdateSuccess',
        component: SuccessPage,
        meta: { rule: 'isSchoolAdmin' },
        props: { type: 'userschool-update' }
      }
    ]
  },

  // School :: Teacher
  {
    path: '/teacher',
    component: Wrapper,
    meta: { breadCrumb: 'content.teacher_list' },
    children: [
      {
        path: '',
        name: 'TeacherIndex',
        component: () => import(/* webpackChunkName: "teacher-index" */ '@/pages/teacher'),
        meta: { rule: 'isSchoolAdmin', layout: 'default' }
      },
      {
        path: 'create',
        name: 'CreateTeacher',
        component: () => import(/* webpackChunkName: "teacher-form" */ '@/pages/teacher/CreateEdit'),
        meta: { rule: 'isSchoolAdmin', layout: 'default', breadCrumb: 'content.teacher_create' }
      },
      {
        path: ':id/edit',
        name: 'EditTeacher',
        component: () => import(/* webpackChunkName: "teacher-form" */ '@/pages/teacher/CreateEdit'),
        meta: { rule: 'isSchoolAdmin', layout: 'default', breadCrumb: 'content.teacher_edit' }
      },
      {
        path: ':id/view',
        name: 'DetailTeacher',
        component: () => import(/* webpackChunkName: "school-form" */ '@/pages/teacher/CreateEdit'),
        meta: { rule: 'isSchoolAdmin', layout: 'default', breadCrumb: 'content.teacher_detail' },
        props: { editable: false }
      },
      {
        path: 'success',
        name: 'TeacherSuccess',
        component: SuccessPage,
        meta: { rule: 'isSchoolAdmin', layout: 'empty' },
        props: { type: 'teacher' }
      },
      {
        path: 'success',
        name: 'TeacherUpdateSuccess',
        component: SuccessPage,
        meta: { rule: 'isSchoolAdmin', layout: 'empty' },
        props: { type: 'teacher-update' }
      }
    ]
  },

  // School :: Student
  {
    path: '/student',
    component: Wrapper,
    meta: { breadCrumb: 'content.student_list' },
    children: [
      {
        path: '',
        name: 'StudentIndex',
        component: () => import(/* webpackChunkName: "student-index" */ '@/pages/student'),
        meta: { rule: 'isSchoolAdminAdvisor', layout: 'default' }
      }
      // {
      //   path: 'create',
      //   name: 'CreateStudent',
      //   component: () => import(/* webpackChunkName: "student-form" */ '@/pages/student/CreateEdit'),
      //   meta: { rule: 'isSchoolAdmin', layout: 'default', breadCrumb: 'content.student_create' }
      // },
      // {
      //   path: ':id/edit',
      //   name: 'EditStudent',
      //   component: () => import(/* webpackChunkName: "student-form" */ '@/pages/student/CreateEdit'),
      //   meta: { rule: 'isSchoolAdmin', layout: 'default', breadCrumb: 'content.student_edit' }
      // },
      // {
      //   path: ':id/view',
      //   name: 'ViewStudent',
      //   component: () => import(/* webpackChunkName: "student-form" */ '@/pages/student/CreateEdit'),
      //   meta: { rule: 'isSchoolAdminAdvisor', layout: 'default', breadCrumb: 'content.student_view' },
      //   props: { editable: false }
      // },
      // {
      //   path: 'success',
      //   name: 'StudentSuccess',
      //   component: SuccessPage,
      //   meta: { rule: 'isSchoolAdmin' },
      //   props: { type: 'student-school' }
      // },
      // {
      //   path: 'success',
      //   name: 'StudentUpdateSuccess',
      //   component: SuccessPage,
      //   meta: { rule: 'isSchoolAdmin' },
      //   props: { type: 'student-school-update' }
      // }
    ]
  },

  // School :: Parent
  {
    path: '/parent',
    component: Wrapper,
    meta: { breadCrumb: 'content.parent_list' },
    children: [
      {
        path: '',
        name: 'ParentIndex',
        component: () => import(/* webpackChunkName: "parent-index" */ '@/pages/parent'),
        meta: { rule: 'isSchoolAdminAdvisor', layout: 'default' }
      },
      {
        path: 'create',
        name: 'CreateParent',
        component: () => import(/* webpackChunkName: "parent-form" */ '@/pages/parent/CreateEdit'),
        meta: { rule: 'isSchoolAdmin', layout: 'default', breadCrumb: 'content.parent_create' }
      },
      {
        path: ':id/edit',
        name: 'EditParent',
        component: () => import(/* webpackChunkName: "parent-form" */ '@/pages/parent/CreateEdit'),
        meta: { rule: 'isSchoolAdmin', layout: 'default', breadCrumb: 'content.parent_edit' }
      },
      {
        path: ':id/view',
        name: 'ViewParent',
        component: () => import(/* webpackChunkName: "parent-form" */ '@/pages/parent/CreateEdit'),
        meta: { rule: 'isSchoolAdminAdvisor', layout: 'default', breadCrumb: 'content.parent_view' },
        props: { editable: false }
      },
      {
        path: ':id/student-view/:userId',
        name: 'ViewStudent',
        component: () => import(/* webpackChunkName: "parent-form" */ '@/pages/parent/CreateEdit'),
        meta: { rule: 'isSchoolAdminAdvisor', layout: 'default', breadCrumb: 'content.student_view' },
        props: { editable: false }
      },
      {
        path: ':id/add-student',
        name: 'AddStudent',
        component: () => import(/* webpackChunkName: "parent-form" */ '@/pages/parent/CreateEdit'),
        meta: { rule: 'isSchoolAdmin', layout: 'default', breadCrumb: 'content.student_create' }
      },
      {
        path: ':id/edit-student/:userId',
        name: 'EditStudent',
        component: () => import(/* webpackChunkName: "parent-form" */ '@/pages/parent/CreateEdit'),
        meta: { rule: 'isSchoolAdmin', layout: 'default', breadCrumb: 'content.student_edit' }
      },
      {
        path: ':id/add-student/success',
        name: 'ParentAddStudentSuccess',
        component: SuccessPage,
        meta: { rule: 'isSchoolAdmin' },
        props: { type: 'parent-add-student-school' }
      },
      {
        path: ':id/edit-student/success',
        name: 'ParentEditStudentSuccess',
        component: SuccessPage,
        meta: { rule: 'isSchoolAdmin' },
        props: { type: 'parent-edit-student-school' }
      },
      {
        path: ':id/edit-parent/success',
        name: 'ParentStudentEditSuccess',
        component: SuccessPage,
        meta: { rule: 'isSchoolAdmin' },
        props: { type: 'parent-student-edit' }
      }
    ]
  },

  // School :: Class Level
  {
    path: '/class-level',
    component: Wrapper,
    meta: { breadCrumb: 'content.class_level_list' },
    children: [
      {
        path: '',
        name: 'ClassLevelIndex',
        component: () => import(/* webpackChunkName: "class-level-index" */ '@/pages/class-level'),
        meta: { rule: 'isSchoolAdminAdvisor', layout: 'default' }
      },
      {
        path: 'create',
        name: 'ClassLevelCreate',
        component: () => import(/* webpackChunkName: "class-level-form" */ '@/pages/class-level/CreateEdit'),
        meta: { rule: 'isSchoolAdmin', layout: 'default', breadCrumb: 'content.class_level_create' }
      },
      {
        path: ':id/edit',
        name: 'ClassLevelEdit',
        component: () => import(/* webpackChunkName: "class-level-form" */ '@/pages/class-level/CreateEdit'),
        meta: { rule: 'isSchoolAdmin', layout: 'default', breadCrumb: 'content.class_level_edit' }
      },
      {
        path: 'success',
        name: 'ClassLevelSuccess',
        component: SuccessPage,
        meta: { rule: 'isSchoolAdmin' },
        props: { type: 'class-level' }
      },
      {
        path: 'success',
        name: 'ClassLevelUpdateSuccess',
        component: SuccessPage,
        meta: { rule: 'isSchoolAdmin' },
        props: { type: 'class-level-update' }
      }
    ]
  },

  // School :: Course
  {
    path: '/course',
    component: Wrapper,
    meta: { breadCrumb: 'content.course_list' },
    children: [
      {
        path: '',
        name: 'CourseIndex',
        component: () => import(/* webpackChunkName: "course-index" */ '@/pages/course'),
        meta: { rule: 'isSchoolAdminTeacherAdvisor', layout: 'default' }
      },
      {
        path: 'create',
        name: 'CreateCourse',
        component: () => import(/* webpackChunkName: "course-form" */ '@/pages/course/CreateEdit'),
        meta: { rule: 'isSchoolAdminTeacher', layout: 'default', breadCrumb: 'form.course_create' }
      },
      {
        path: ':id/edit',
        name: 'EditCourse',
        component: () => import(/* webpackChunkName: "course-form" */ '@/pages/course/CreateEdit'),
        meta: { rule: 'isSchoolAdminTeacher', layout: 'default', breadCrumb: 'form.course_edit' }
      },
      {
        path: 'success',
        name: 'CourseSuccess',
        component: SuccessPage,
        meta: { rule: 'isSchoolAdminTeacher' },
        props: { type: 'course' }
      },
      {
        path: 'success',
        name: 'CourseUpdateSuccess',
        component: SuccessPage,
        meta: { rule: 'isSchoolAdminTeacher' },
        props: { type: 'course-update' }
      }
    ]
  },

  // School :: Class
  {
    path: '/class',
    component: Wrapper,
    meta: { breadCrumb: 'menu.class_list' },
    children: [
      {
        path: '',
        name: 'SchoolClassIndex',
        component: () => import(/* webpackChunkName: "school-class-index" */ '@/pages/class'),
        meta: { rule: 'isSchoolAdminTeacherAdvisor', layout: 'default' }
      },
      {
        path: 'create',
        name: 'CreateSchoolClass',
        component: () => import(/* webpackChunkName: "school-class-form" */ '@/pages/class/CreateEdit'),
        meta: { rule: 'isSchoolAdmin', layout: 'default', breadCrumb: 'content.class_create' }
      },
      {
        path: ':id/edit',
        name: 'EditSchoolClass',
        component: () => import(/* webpackChunkName: "school-class-form" */ '@/pages/class/CreateEdit'),
        meta: { rule: 'isSchoolAdmin', layout: 'default', breadCrumb: 'content.class_edit' }
      },
      {
        path: ':id/view',
        component: Wrapper,
        meta: { breadCrumb: 'content.class_detail' },
        children: [
          {
            path: '',
            name: 'ViewSchoolClass',
            component: () => import(/* webpackChunkName: "school-class-form" */ '@/pages/class/View'),
            meta: { rule: 'isSchoolAdminAdvisor', layout: 'default' }
          },
          {
            path: ':classId/class/:courseId/course',
            component: Wrapper,
            meta: { breadCrumb: 'content.class_section' },
            children: [
              {
                path: '',
                name: 'ViewSchoolClassSection',
                component: () => import(/* webpackChunkName: "school-class-form" */ '@/pages/class/ViewSection'),
                meta: { rule: 'isSchoolAdminAdvisor', layout: 'default' }
              }
            ]
          },
          {
            path: 'template-erapor',
            component: Wrapper,
            meta: { breadCrumb: 'content.template_e_rapor' },
            children: [
              {
                path: '',
                name: 'eRaporTemplateSchoolAdminIndex',
                component: () => import(/* webpackChunkName: "template-e-rapor" */ '@/pages/template_generator'),
                meta: { rule: 'isSchoolAdmin', layout: 'default' },
                props: { editable: false, type: 'template' }
              },
              {
                path: 'create',
                name: 'eRaporTemplateSchoolAdminCreate',
                component: () => import(/* webpackChunkName: "quiz-form" */ '@/pages/template_generator/CreateEditTemplate'),
                meta: { rule: 'isSchoolAdmin', layout: 'default', breadCrumb: 'content.template_e_rapor_create' }
              },
              {
                path: 'edit/:idTemplate',
                name: 'eRaporTemplateSchoolAdminEdit',
                component: () => import(/* webpackChunkName: "quiz-form" */ '@/pages/template_generator/CreateEditTemplate'),
                meta: { rule: 'isSchoolAdmin', layout: 'default', breadCrumb: 'content.template_e_rapor_edit' },
                props: { isEditable: false }
              },
              {
                path: 'view/:idTemplate',
                name: 'eRaporTemplateSchoolAdminView',
                component: () => import(/* webpackChunkName: "teacher-attendance" */ '@/pages/template_generator/CreateEditTemplate'),
                meta: { rule: 'isSchoolAdmin', layout: 'default', breadCrumb: 'content.template_e_rapor_view' },
                props: { isEditable: true }
              },
              {
                path: 'success',
                name: 'eRaporTemplateSchoolAdminSuccess',
                component: SuccessPage,
                meta: { rule: 'isSchoolAdmin' },
                props: { type: 'erapor-template-schooladmin' }
              },
              {
                path: 'success',
                name: 'eRaporTemplateSchoolAdminUpdateSuccess',
                component: SuccessPage,
                meta: { rule: 'isSchoolAdmin' },
                props: { type: 'erapor-template-schooladmin-update' }
              }
            ]
          },
          {
            path: 'erapor-list',
            component: Wrapper,
            meta: { breadCrumb: 'content.erapor' },
            children: [
              {
                path: '',
                name: 'EraporSchoolAdminView',
                component: () => import(/* webpackChunkName: "teacher-course" */ '@/pages/template_generator/ListStudent'),
                meta: { rule: 'isSchoolAdmin', layout: 'default' },
                props: { type: 'school-admin' }
              },
              {
                path: 'view/:studentId',
                name: 'eRaporGeneratorViewStudentSchoolAdminClass',
                component: () => import(/* webpackChunkName: "teacher-course" */ '@/pages/template_generator/Template'),
                meta: { rule: 'isSchoolAdmin', layout: 'default', breadCrumb: 'content.template_generate_view' },
                props: { type: 'school-admin', isEditable: false }
              }
            ]
          }
        ]
      },
      {
        path: 'success',
        name: 'SchoolClassSuccess',
        component: SuccessPage,
        meta: { rule: 'isSchoolAdmin' },
        props: { type: 'school-class' }
      },
      {
        path: 'success',
        name: 'SchoolClassSuccessUpdate',
        component: SuccessPage,
        meta: { rule: 'isSchoolAdmin' },
        props: { type: 'school-class-update' }
      }
    ]
  },

  // School :: Enroll Student
  {
    path: '/enrollstudent',
    component: Wrapper,
    meta: { breadCrumb: 'content.group_list' },
    children: [
      {
        path: '',
        name: 'EnrollStudentIndex',
        component: () => import(/* webpackChunkName: "school-class-index" */ '@/pages/enroll'),
        meta: { rule: 'isSchoolAdminAdvisor', layout: 'default' }
      },
      {
        path: 'create',
        name: 'CreateEnrollStudent',
        component: () => import(/* webpackChunkName: "school-class-form" */ '@/pages/enroll/CreateEdit'),
        meta: { rule: 'isSchoolAdmin', layout: 'default', breadCrumb: 'content.class_create' }
      },
      {
        path: ':id/edit',
        name: 'EditEnrollStudent',
        component: () => import(/* webpackChunkName: "school-class-form" */ '@/pages/enroll/CreateEdit'),
        meta: { rule: 'isSchoolAdmin', layout: 'default', breadCrumb: 'content.class_edit' }
      },
      {
        path: 'success',
        name: 'SchoolGroupSuccess',
        component: SuccessPage,
        meta: { rule: 'isSchoolAdmin' },
        props: { type: 'group' }
      },
      {
        path: 'success',
        name: 'SchoolGroupSuccessUpdate',
        component: SuccessPage,
        meta: { rule: 'isSchoolAdmin' },
        props: { type: 'group-update' }
      }
    ]
  },

  // School :: Report
  {
    path: '/report-school',
    name: 'ReportSchoolIndex',
    component: () => import(/* webpackChunkName: "report-school-index" */ '@/pages/report/School'),
    meta: { rule: 'isSchoolAdminAdvisor', layout: 'default', breadCrumb: 'menu.report' }
  },

  // School :: Setting Class
  {
    path: '/setting-class',
    component: Wrapper,
    meta: { breadCrumb: 'content.setting_class' },
    children: [
      {
        path: '',
        name: 'MenuListClass',
        component: MenuLite,
        meta: { rule: 'isSchoolAdmin', layout: 'default' },
        props: { type: 'school-admin' }
      },
      {
        path: 'cerdas-setting',
        name: 'ClassSettingIndex',
        component: () => import(/* webpackChunkName: "role-index" */ '@/pages/class-setting'),
        meta: { rule: 'isSchoolAdmin', layout: 'default', breadCrumb: 'content.class_level' }
      },
      {
        path: 'change-accel',
        component: Wrapper,
        meta: { breadCrumb: 'content.class_accel' },
        children: [
          {
            path: '',
            name: 'ClassAccelIndex',
            component: () => import(/* webpackChunkName: "role-index" */ '@/pages/class-accel'),
            meta: { rule: 'isSchoolAdmin', layout: 'default' }
          },
          {
            path: 'create',
            name: 'CreateClassAccel',
            component: () => import(/* webpackChunkName: "school-class-form" */ '@/pages/class-accel/CreateEdit'),
            meta: { rule: 'isSchoolAdmin', layout: 'default', breadCrumb: 'content.class_accel_create' }
          },
          {
            path: ':id/edit',
            name: 'EditClassAccel',
            component: () => import(/* webpackChunkName: "school-class-form" */ '@/pages/class-accel/CreateEdit'),
            meta: { rule: 'isSchoolAdmin', layout: 'default', breadCrumb: 'content.class_accel_edit' }
          },
          {
            path: 'success',
            name: 'ClassAccelSuccess',
            component: SuccessPage,
            meta: { rule: 'isSchoolAdmin' },
            props: { type: 'accel-class' }
          },
          {
            path: 'success',
            name: 'ClassAccelSuccessUpdate',
            component: SuccessPage,
            meta: { rule: 'isSchoolAdmin' },
            props: { type: 'accel-class-update' }
          }
        ]
      }
    ]
  },

  // School :: Analytical
  {
    path: '/analytic-list',
    component: Wrapper,
    meta: { breadCrumb: 'content.anal' },
    children: [
      {
        path: '',
        name: 'MenuListAnalytical',
        component: MenuAnalitic,
        meta: { rule: 'isSchoolAdmin', layout: 'default' },
        props: { type: 'school-admin' }
      },
      // Analytical teacher
      {
        path: 'analytical-teacher',
        component: Wrapper,
        children: [
          {
            path: '',
            name: 'AnalyticTeacherList',
            component: () => import(/* webpackChunkName: "role-index" */ '@/pages/analytic-teacher'),
            meta: { rule: 'isSchoolAdmin', layout: 'default' },
            props: { type: 'teacher' }
          },
          {
            path: ':idSidebar',
            component: Wrapper,
            meta: { breadCrumb: 'content.anal_teacher' },
            children: [
              {
                path: '',
                name: 'AnalyticTeacherListID',
                component: () => import(/* webpackChunkName: "role-index" */ '@/pages/analytic-teacher'),
                meta: { rule: 'isSchoolAdmin', layout: 'default' },
                props: { type: 'teacher' }
              },
              {
                path: 'create-category',
                name: 'CreateCategoryTeacher',
                component: () => import(/* webpackChunkName: "school-class-form" */ '@/pages/analytic-teacher/CreateEditCategory'),
                meta: { rule: 'isSchoolAdmin', layout: 'default', breadCrumb: 'content.add_category' },
                props: { type: 'teacher' }
              },
              {
                path: 'edit-category/:idCategory',
                component: Wrapper,
                meta: { breadCrumb: 'content.edit_category' },
                children: [
                  {
                    path: '',
                    name: 'EditCategoryTeacher',
                    component: () => import(/* webpackChunkName: "school-class-form" */ '@/pages/analytic-teacher/CreateEditCategory'),
                    meta: { rule: 'isSchoolAdmin', layout: 'default' },
                    props: { type: 'teacher' }
                  }
                ]
              },
              {
                path: 'success',
                name: 'CategoryTeacherSuccess',
                component: SuccessPage,
                meta: { rule: 'isSchoolAdmin' },
                props: { type: 'category-teacher' }
              },
              {
                path: 'success',
                name: 'CategoryTeacherSuccessUpdate',
                component: SuccessPage,
                meta: { rule: 'isSchoolAdmin' },
                props: { type: 'category-teacher-teacher' }
              },
              {
                path: 'create-template',
                name: 'CreateTemplateTeacher',
                component: () => import(/* webpackChunkName: "school-class-form" */ '@/pages/analytic-teacher/CreateEditTemplate'),
                meta: { rule: 'isSchoolAdmin', layout: 'default', breadCrumb: 'content.add_template' },
                props: { type: 'teacher' }
              },
              {
                path: 'edit-template/:idTemplate',
                name: 'EditTemplateTeacher',
                component: () => import(/* webpackChunkName: "school-class-form" */ '@/pages/analytic-teacher/CreateEditTemplate'),
                meta: { rule: 'isSchoolAdmin', layout: 'default', breadCrumb: 'content.edit_template' },
                props: { type: 'teacher' }
              },
              {
                path: 'use-template/:idTemplate',
                name: 'UseTemplateTeacher',
                component: () => import(/* webpackChunkName: "school-class-form" */ '@/pages/analytic-teacher/CreateEditQuiz'),
                meta: { rule: 'isSchoolAdmin', layout: 'default', breadCrumb: 'content.use_template' },
                props: { type: 'teacher' }
              },
              {
                path: 'success',
                name: 'UseTemplateTeacherSuccess',
                component: SuccessPage,
                meta: { rule: 'isSchoolAdmin' },
                props: { type: 'use-template-teacher' }
              },
              {
                path: 'success',
                name: 'TemplateTeacherSuccess',
                component: SuccessPage,
                meta: { rule: 'isSchoolAdmin' },
                props: { type: 'template-teacher' }
              },
              {
                path: 'success',
                name: 'TemplateTeacherSuccessUpdate',
                component: SuccessPage,
                meta: { rule: 'isSchoolAdmin' },
                props: { type: 'template-teacher-teacher' }
              }
            ]
          }
        ]
      },
      // Analytical student
      {
        path: 'analytical-student',
        component: Wrapper,
        children: [
          {
            path: '',
            name: 'AnalyticStudentList',
            component: () => import(/* webpackChunkName: "role-index" */ '@/pages/analytic-teacher'),
            meta: { rule: 'isSchoolAdmin', layout: 'default', breadCrumb: 'content.anal_student' },
            props: { type: 'student' }
          },
          {
            path: ':idSidebar',
            component: Wrapper,
            meta: { breadCrumb: 'content.anal_student' },
            children: [
              {
                path: '',
                name: 'AnalyticStudentListID',
                component: () => import(/* webpackChunkName: "role-index" */ '@/pages/analytic-teacher'),
                meta: { rule: 'isSchoolAdmin', layout: 'default' },
                props: { type: 'student' }
              },
              {
                path: 'create-category',
                name: 'CreateCategoryStudent',
                component: () => import(/* webpackChunkName: "school-class-form" */ '@/pages/analytic-teacher/CreateEditCategory'),
                meta: { rule: 'isSchoolAdmin', layout: 'default', breadCrumb: 'content.add_category' },
                props: { type: 'student' }
              },
              {
                path: 'edit-category/:idCategory',
                component: Wrapper,
                meta: { breadCrumb: 'content.edit_category' },
                children: [
                  {
                    path: '',
                    name: 'EditCategoryStudent',
                    component: () => import(/* webpackChunkName: "school-class-form" */ '@/pages/analytic-teacher/CreateEditCategory'),
                    meta: { rule: 'isSchoolAdmin', layout: 'default' },
                    props: { type: 'student' }
                  }
                ]
              },
              {
                path: 'success',
                name: 'CategoryStudentSuccess',
                component: SuccessPage,
                meta: { rule: 'isSchoolAdmin' },
                props: { type: 'category-student' }
              },
              {
                path: 'success',
                name: 'CategoryStudentSuccessUpdate',
                component: SuccessPage,
                meta: { rule: 'isSchoolAdmin' },
                props: { type: 'category-student-teacher' }
              },
              {
                path: 'create-template-student',
                name: 'CreateTemplateStudent',
                component: () => import(/* webpackChunkName: "school-class-form" */ '@/pages/analytic-teacher/CreateEditTemplate'),
                meta: { rule: 'isSchoolAdmin', layout: 'default', breadCrumb: 'content.add_template' },
                props: { type: 'student' }
              },
              {
                path: 'edit-template-student/:idTemplate',
                name: 'EditTemplateStudent',
                component: () => import(/* webpackChunkName: "school-class-form" */ '@/pages/analytic-teacher/CreateEditTemplate'),
                meta: { rule: 'isSchoolAdmin', layout: 'default', breadCrumb: 'content.edit_template' },
                props: { type: 'student' }
              },
              {
                path: 'success',
                name: 'TemplateStudentSuccess',
                component: SuccessPage,
                meta: { rule: 'isSchoolAdmin' },
                props: { type: 'template-student' }
              },
              {
                path: 'success',
                name: 'TemplateStudentSuccessUpdate',
                component: SuccessPage,
                meta: { rule: 'isSchoolAdmin' },
                props: { type: 'template-teacher-student' }
              },
              {
                path: 'use-template/:idTemplate',
                name: 'UseTemplateStudent',
                component: () => import(/* webpackChunkName: "school-class-form" */ '@/pages/analytic-teacher/CreateEditQuizStudent'),
                meta: { rule: 'isSchoolAdmin', layout: 'default', breadCrumb: 'content.use_template' },
                props: { type: 'student' }
              },
              {
                path: 'success',
                name: 'UseTemplateStudentSuccess',
                component: SuccessPage,
                meta: { rule: 'isSchoolAdmin' },
                props: { type: 'use-template-student' }
              },
              // {
              //   path: 'success',
              //   name: 'UseTemplateStudentSuccess',
              //   component: SuccessPage,
              //   meta: { rule: 'isSchoolAdmin' },
              //   props: { type: 'use-template-student' }
              // },
              {
                path: 'view-result/:idResult',
                component: Wrapper,
                meta: { breadCrumb: 'content.view_anal_student' },
                children: [
                  {
                    path: '',
                    name: 'viewResultStudent',
                    component: () => import(/* webpackChunkName: "school-class-form" */ '@/pages/analytic-teacher/ListStudentResult'),
                    meta: { rule: 'isSchoolAdmin', layout: 'default' },
                    props: { type: 'student' }
                  },
                  {
                    path: 'student-view/:idStudent',
                    component: Wrapper,
                    meta: { breadCrumb: 'content.detail_anal_student' },
                    children: [
                      {
                        path: '',
                        name: 'detailResultStudent',
                        component: () => import(/* webpackChunkName: "school-class-form" */ '@/pages/analytic-teacher/DetailAnaliticStudent'),
                        meta: { rule: 'isSchoolAdmin', layout: 'default' },
                        props: { type: 'student' }
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },
      // Analytical Class
      {
        path: 'analytical-class',
        component: Wrapper,
        meta: { breadCrumb: 'content.class_list' },
        children: [
          {
            path: '',
            name: 'AnalyticClassList',
            component: () => import(/* webpackChunkName: "role-index" */ '@/pages/analytic-teacher/ListClass'),
            meta: { rule: 'isSchoolAdmin', layout: 'default' }
          },
          {
            path: ':idClass',
            component: Wrapper,
            meta: { breadCrumb: 'content.anal_class' },
            children: [
              {
                path: '',
                name: 'AnalyticClassView',
                component: () => import(/* webpackChunkName: "role-index" */ '@/pages/analytic-teacher/ViewClassDetail'),
                meta: { rule: 'isSchoolAdmin', layout: 'default' },
                props: { type: 'class' }
              }
            ]
          }
        ]
      }
    ]
  }
];
